import React from 'react'
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';

export const getRemovalColumns = (handleCancelRemove, isActive, exchange) => {
	return [
		{
			title: 'Name',
			key: 'name',
			render: (item) => (
				<div>
					{isActive
						?
							<div className="name-column">
								{exchange.id === item.exchange_id
									?
										<Icon type="star" />
									: null
								}{' '}
								{item.Exchange.name}
								{exchange.id === item.exchange_id
									?
										<span>(your project)</span>
									: null
								}{' '}
								(<Link to={'/collateral'}>View</Link>)
							</div>
						:
							<div className="name-column">
								{item.Exchange.name}
							</div>
					}
				</div>
			)
		},
		{
			title: 'Amount (XHT)',
			key: 'amount',
			render: (item) => <div>{item.amount}</div>
		},
		{
			title: 'Receiving address',
			key: 'receiving_address',
			render: (item) => <div>{item.address}</div>
		},
		{
			title: 'Time left (days)',
			key: 'time_left',
			render: (item) => {
				const total_time = moment(item.close_timestamp).diff(moment(), 'days');
				const percent = Math.floor(((365 - total_time) / 365) * 100);
				return (
					<div className='d-flex'>
						<div>{total_time}</div>
						<div className="progress-bar">
							<div className="progress-bar-blue" style={{ height: '15px', width: `${percent}%` }}></div>
						</div>
					</div>
				);
			}
		},
		{
			title: 'Cancel',
			key: 'cancel',
			render: (item) => <span className="anchor" onClick={() => handleCancelRemove(item)}>Cancel removal</span>
		}
	];
};